import type { FormInstance } from '@arco-design/web-react';

import type { VendorDeviceMeta } from '../vendorDevice';
import { DISK_PRICING_FIELD, syncVendorDeviceMetaToInnerForm } from '../vendorDevice';
import type { DiskPricingListItem } from './types';

/** 列表磁盘计价字段同步到 innerForm */
export function syncDiskListPricingToInnerForm<T>(
  form: FormInstance,
  listPath: string,
  list: T[],
  filter?: (item: T, index: number) => boolean,
): void {
  list.forEach((item, index) => {
    if (filter && !filter(item, index)) return;
    syncVendorDeviceMetaToInnerForm(form, `${listPath}.${index}.pricing`, (item as DiskPricingListItem).pricing);
  });
}

/** 弹窗 init 时写入 pricing 字段 */
export function buildDiskPricingInitPatch(pricing?: VendorDeviceMeta | null): Record<string, unknown> {
  return pricing ? { [DISK_PRICING_FIELD]: pricing } : {};
}
